import { useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import BaseInput from '../../components/BasicComponent/BaseInput'
import BasePopup from '../../components/BasicComponent/BasePopup'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import SafeImage from '../../components/BasicComponent/SafeImage'
import { PATH } from '../../constants/router'
import phoneIntro from '../../assets/images/phoneintro.png'
import phoneNumberBackground from '../../assets/images/Phone_number_background.png'
import trafficFineBenefits1 from '../../assets/images/traffic_fine_benifits_1.png'
import trafficFineBenefits2 from '../../assets/images/traffic_fine_benifits_2.png'
import trafficFineBenefits3 from '../../assets/images/traffic_fine_benifits_3.png'
import trafficFineBenefits4 from '../../assets/images/traffic_fine_benifits_12.png'
import trafficFineBenefits5 from '../../assets/images/traffic_fine_benifits_5.png'
import trafficFineBenefits9 from '../../assets/images/traffic_fine_benifits_9.png'
import trafficFineBenefits10 from '../../assets/images/traffic_fine_benifits_10.png'
import { useAppUserContext } from '../../context/AppUserContext'
import { useAppParamsContext } from '../../context/AppParamsContext'
import useThemeFeatureConfig from '../../hooks/common/useThemeFeatureConfig'
import './index.scss'

const normalizePhoneNumber = (value) => String(value || '').replace(/\D/g, '').slice(0, 10)

const isValidPhoneNumber = (value) => /^0\d{9}$/.test(value)

const benefitItems = [
  { icon: trafficFineBenefits1, text: 'Tra cứu phạt nguội nhanh chóng, tiện lợi' },
  { icon: trafficFineBenefits2, text: 'Cập nhật thông tin vi phạm tự động' },
  { icon: trafficFineBenefits3, text: 'Quản lý xe và gói dịch vụ dễ dàng' },
  { icon: trafficFineBenefits4, text: 'Nhận thông báo khi có phát sinh mới' },
  { icon: trafficFineBenefits5, text: 'Theo dõi trạng thái đăng ký minh bạch' },
  { icon: trafficFineBenefits9, text: 'Thanh toán nhanh chóng, an toàn' },
  { icon: trafficFineBenefits10, text: 'Hỗ trợ sử dụng dịch vụ mọi lúc' }
]

export default function TrafficFinePhoneAuth() {
  const history = useHistory()
  const location = useLocation()
  const { confirmManualPhoneUserData } = useAppUserContext()
  const { isHeaderMiniApp } = useAppParamsContext()
  const { phoneAuthBannerVariant = 1 } = useThemeFeatureConfig('TRAFFIC_FINE_PHONE_AUTH')

  const phoneAuthImage = phoneAuthBannerVariant === 2
    ? phoneNumberBackground
    : phoneIntro
  
  const [phone, setPhone] = useState('')
  const [error, setError] = useState('')
  const [popupError, setPopupError] = useState(null)
  const [loading, setLoading] = useState(false)

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])

  const handleChange = (event) => {
    setPhone(normalizePhoneNumber(event.target.value))
    setError('')
  }

  const handleSubmit = () => {
    const safePhone = normalizePhoneNumber(phone)

    if (!safePhone) {
      setError('Vui lòng nhập số điện thoại')
      return
    }

    if (!isValidPhoneNumber(safePhone)) {
      setError('Số điện thoại không hợp lệ')
      return
    }

    const isConfirmed = confirmManualPhoneUserData(safePhone)

    if (!isConfirmed) {
      setPopupError({
        title: 'Không thể xác thực',
        content: 'Số điện thoại không hợp lệ. Vui lòng kiểm tra lại.'
      })
      return
    }

    setLoading(true)

    const nextSearchParams = new URLSearchParams(searchParams)
    nextSearchParams.set('phoneNumber', safePhone)

    const savedReferUserCode = localStorage.getItem('referUserCode')

    if (savedReferUserCode && !nextSearchParams.get('referUserCode')) {
      nextSearchParams.set('referUserCode', savedReferUserCode)
    }

    history.replace({
      pathname: PATH.TRAFFIC_FINE_LOOKUP,
      search: `?${nextSearchParams.toString()}`
    })
  }

  return (
    <LayoutPartner noHeader={!isHeaderMiniApp} headerTitle="Xác thực số điện thoại" blendHeaderWithBody>

      <div className="TrafficFinePhoneAuth">
      <div className="TrafficFinePhoneAuth_hero">
        <div className="TrafficFinePhoneAuth_intro">
          <SafeImage
            src={phoneAuthImage}
            alt="Xác thực số điện thoại"
            className="TrafficFinePhoneAuth_introImage"
          />
        </div>
      </div>

        <div className="TrafficFinePhoneAuth_content">
          <div className="TrafficFinePhoneAuth_card">
            <div className="TrafficFinePhoneAuth_title">Nhập số điện thoại</div>

            <div className="TrafficFinePhoneAuth_desc">
              Nhập số điện thoại của bạn để tiếp tục tra cứu phạt nguội hoặc mua gói thông báo tự động.
            </div>

            <div className="TrafficFinePhoneAuth_input">
              <BaseInput
                value={phone}
                placeholder="Ví dụ: 0987654321"
                onChange={handleChange}
                showClear={Boolean(phone)}
                onClear={() => {
                  setPhone('')
                  setError('')
                }}
                error={error}
                inputMode="numeric"
                maxLength={10}
              />
            </div>
          </div>

          <div className="TrafficFinePhoneAuth_benefit">
            <div className="TrafficFinePhoneAuth_benefitTitle">Bạn sẽ nhận được</div>

            {benefitItems.map((item) => (
              <div className="TrafficFinePhoneAuth_benefitItem" key={item.text}>
                <div className="TrafficFinePhoneAuth_benefitIcon">
                  <SafeImage src={item.icon} alt="" />
                </div>

                <div>{item.text}</div>
              </div>
            ))}
          </div>
        </div>

        <BasePopup
          open={!!popupError}
          title={popupError?.title}
          content={popupError?.content}
          onClose={() => setPopupError(null)}
        />

        <LoadingScreen open={loading} />
      </div>

      <FixedBottom elementPaddingBottom="LayoutPartner">
        <div className="TrafficFinePhoneAuth_bottom">
          <BaseButton disabled={!phone || loading} onClick={handleSubmit}>
            Xác nhận
          </BaseButton>
        </div>
      </FixedBottom>
    </LayoutPartner>
  )
}